/**
 *
 * @param {Spinner} spinner
 */
export function setupZoomControls(spinner) {
  const zoomIn = spinner.addActionButton("zoom-in", () => {
    spinner.setZoomScale(
      spinner.uiWidth / 2,
      spinner.uiHeight / 2,
      spinner.zoomScale + 1,
    );
  });
  zoomIn.classList.add("desktop-only");

  const zoomOut = spinner.addActionButton("zoom-out", () => {
    spinner.setZoomScale(
      spinner.uiWidth / 2,
      spinner.uiHeight / 2,
      spinner.zoomScale - 1,
    );
  });
  zoomOut.classList.add("desktop-only");

  spinner.on("layerchange", (event) => {
    if (event.detail.layer.type === "interior") {
      zoomIn.disabled = true;
      zoomOut.disabled = true;
    } else {
      zoomIn.disabled = false;
      zoomOut.disabled = false;
    }
  });

  if (spinner.hideZoom) {
    zoomIn.remove();
    zoomOut.remove();
  }
}
